import GetCredentialOAuthS2s from '/src/pages/credential/GetCredentialOAuthS2s.js';
import * as React from 'react';
export default {
  GetCredentialOAuthS2s,
  React
};